module.exports = __webpack_public_path__ + "img/paint_sinister_staining.daad1b06.png";